import { render, staticRenderFns } from "./PetBreed.vue?vue&type=template&id=a25b49c2"
import script from "./PetBreed.vue?vue&type=script&lang=js"
export * from "./PetBreed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports